/* Kartograf · caricamento di logo, anteprima e file originale sul Worker (/upload), comune ai configuratori nuovi.
   Stessa logica di kg-config-attivo.js. WORKER: window.KG_WORKER_URL (vuoto = disattivato) o il predefinito qui sotto.
   Uso: KGUP.attivo() → true/false;  KGUP.carica({ logo: canvas|null, anteprima: dataURL|canvas, originale: File|null })
        → Promise { logo, anteprima, originale } (link /f/ o una nota se manca);  KGUP.proprieta(u) → { Logo, Anteprima, _Originale } */
(function () {
  'use strict';
  var PREDEFINITO = 'https://kg-configuratore.giovanniniforniture.workers.dev';
  var TIPI = ['image/png', 'image/jpeg', 'image/svg+xml', 'application/pdf'], MAX_ORIG = 20 * 1048576;
  function worker() { return String(window.KG_WORKER_URL !== undefined ? window.KG_WORKER_URL : PREDEFINITO).replace(/\/+$/, ''); }
  function png(s) {
    if (!s) return Promise.resolve(null);
    if (typeof s === 'string') return fetch(s).then(function (r) { return r.blob(); });
    return new Promise(function (ok, ko) { s.toBlob(function (b) { b ? ok(b) : ko(new Error('PNG non creato')); }, 'image/png'); });
  }
  function originale(f) {
    if (!f) return { nota: 'non disponibile' };
    if (TIPI.indexOf(f.type) < 0) return { nota: 'non salvato (formato ' + (f.type || 'sconosciuto') + ': vale il Logo PNG)' };
    if (f.size > MAX_ORIG) return { nota: 'non salvato (oltre 20 MB: chiedere il file al cliente)' };
    return { blob: f, nome: f.name || 'originale' };
  }
  function carica(o, tentativo, senzaOrig) {
    var W = worker(), orig = senzaOrig ? { nota: 'non salvato (file rifiutato: vale il Logo PNG)' } : originale(o.originale);
    return Promise.all([png(o.logo), png(o.anteprima)]).then(function (b) {
      var fd = new FormData();
      if (b[0]) fd.append('logo', b[0], 'logo.png');
      if (b[1]) fd.append('anteprima', b[1], 'anteprima.png');
      if (b[0] && orig.blob) fd.append('originale', orig.blob, orig.nome);
      return fetch(W + '/upload', { method: 'POST', body: fd });
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) {
        if (d.errore === 'originale' && orig.blob) return carica(o, tentativo, true);   // l'originale non blocca mai il carrello
        if (!r.ok || !d.ok || !d.anteprima || (o.logo && !d.logo)) throw { messaggio: d.messaggio || 'Non riesco a salvare il logo (' + r.status + '): riprova o scrivici su WhatsApp.', stato: r.status };
        return { logo: d.logo || 'da inviare dopo', anteprima: d.anteprima, originale: d.originale || (o.logo ? orig.nota : 'da inviare dopo') };
      });
    }).catch(function (e) {
      if (!tentativo && !(e && e.stato && e.stato < 500)) return carica(o, 1, senzaOrig);   // un secondo tentativo se cade la rete
      throw e;
    });
  }
  window.KGUP = {
    attivo: function () { return !!worker(); },
    carica: function (o) { return carica(o, 0, false); },
    proprieta: function (u) { return { 'Logo': u.logo, 'Anteprima': u.anteprima, '_Originale': u.originale }; }
  };
})();
